/**
 * Wire-format TypeScript types mirroring ADP.Surveys.Shared DTOs. Naming matches the
 * JSON property names the C# `[JsonPropertyName]` attributes emit — not the C# class
 * names — so these types can be applied directly to the payload served by
 * `GET /surveys/instances/{instanceId}/schema`.
 *
 * Only the subset the SDK uses at runtime is modelled here. The renderer's UI layer
 * may add richer presentational types on top; those belong in the renderer package.
 */
/** Discriminators used at runtime to distinguish the three condition shapes.
 *  Matches the logic in `LogicConditionDtoConverter` on the server side. */
export function isPredicateCondition(c) {
    return typeof c.questionId === 'string';
}
export function isCompositeCondition(c) {
    const cc = c;
    return Array.isArray(cc.all) || Array.isArray(cc.any);
}
export function isExpressionCondition(c) {
    return typeof c.expression === 'string';
}
//# sourceMappingURL=schema.js.map